var departments = document.getElementsByClassName('toggle_department');
for (var i = 0; i < departments.length; i++) {
    id = departments[i].dataset.dropdownId;
    departments[i].addEventListener('click', function(id){
        this.parentElement.classList.toggle('hidden');
    });
}
